import { cloneDeep, isString, isObject, isArray, get, set, startsWith, isFunction, isEqual, extend, isNumber, isBoolean, map } from 'lodash';
class ResourceHistory {
    $_history;
    constructor(data) {
        this.$_history = [cloneDeep(data)];
    }
    first() {
        return this.$_history[0];
    }
    last() {
        return this.$_history[this.$_history.length - 1];
    }
    reset(data) {
        this.$_history.splice(0, this.$_history.length);
        this.$_history.push(cloneDeep(data));
    }
}
function isResourceLike(value) {
    return (isString(get(value, 'id')) &&
        isString(get(value, 'etag')) &&
        isObject(get(value, 'links')));
}
function isResourceContainerLike(value) {
    return (get(value, 'object') === 'list' &&
        isString(get(value, 'self')) &&
        isArray(get(value, 'data')));
}
function isEmbeddedList(value) {
    return get(value, 'object') === 'list' && isArray(get(value, 'data'));
}
const isPrivateKey = (key) => startsWith(key, '$');
export class Resource {
    $_history;
    $_container;
    $_editor = null;
    id;
    etag;
    locked;
    constructor(data, defaults) {
        if (defaults) {
            for (let [k, v] of Object.entries(defaults)) {
                const current_value = get(data, k);
                if (current_value == null) {
                    set(data, k, v);
                }
            }
        }
        this.$_history = new ResourceHistory(data);
        this.init(data);
    }
    get isNew() {
        return this.id == null;
    }
    get isReadOnly() {
        return this.locked === true;
    }
    get isReadonly() {
        return this.locked === true;
    }
    snapshot(field, defaultValue) {
        return get(this.$_history.last(), field, defaultValue);
    }
    getData(options) {
        let result = {};
        const skipNulls = options && options.skipNulls;
        const exclude = options?.exclude;
        const fields = options?.fields;
        for (const [key, value] of Object.entries(this)) {
            if (isPrivateKey(key) || isFunction(value)) {
                continue;
            }
            if (value === null && skipNulls) {
                continue;
            }
            if (fields && fields.indexOf(key) == -1) {
                continue;
            }
            if (exclude && exclude.indexOf(key) > -1) {
                continue;
            }
            result[key] = value;
        }
        return result;
    }
    isValueChanged(key) {
        const first = this.$_history.first();
        console.log(get(this, key), first[key]);
        return !isEqual(get(this, key), first[key]);
    }
    getChanges(options = {
        skipEmbeddedLists: false
    }) {
        const first = this.$_history.first();
        let result = {};
        for (const [key, value] of Object.entries(this)) {
            if (options.skipEmbeddedLists && isEmbeddedList(value)) {
                continue;
            }
            if (isPrivateKey(key) || isFunction(value)) {
                continue;
            }
            if (!isEqual(value, first[key])) {
                result[key] = value;
            }
        }
        return result;
    }
    getURL() {
        const result = get(this, 'self', get(this, 'links.self'));
        if (!isString(result)) {
            throw new Error('Missing URL data.');
        }
        return result;
    }
    getETAG() {
        const result = get(this, '$etag', get(this, 'etag'));
        if (!isString(result)) {
            throw new Error('Missing ETAG data.');
        }
        return result;
    }
    reset(data) {
        this.$_history.reset(data);
        for (const [key, value] of Object.entries(this)) {
            if (isPrivateKey(key) || isFunction(value)) {
                continue;
            }
            set(this, key, undefined);
        }
        extend(this, data);
        if (this.$_editor) {
            this.$_editor.reset(data);
        }
    }
    editor() {
        if (!this.$_editor) {
            this.$_editor = new ResourceEditor(this);
        }
        return this.$_editor;
    }
    clone(overrides) {
        return new Resource(extend(this.getData(), overrides));
    }
    init(data) {
        for (const [key, value] of Object.entries(data)) {
            if (isPrivateKey(key)) {
                continue;
            }
            if (isString(value) ||
                isNumber(value) ||
                value == null ||
                isBoolean(value)) {
                set(this, key, value);
                continue;
            }
            if (isResourceContainerLike(value)) {
                set(this, key, {
                    ...value,
                    data: map(value.data, d => new Resource(d))
                });
                continue;
            }
            set(this, key, value);
        }
    }
}
export class ResourceEditor extends Resource {
    $_resource;
    constructor(resource) {
        super(resource.getData());
        this.$_resource = resource;
    }
}
export function isResourceEditor(value) {
    return value instanceof ResourceEditor;
}
//# sourceMappingURL=resource.js.map